export { InboxComponent } from './src/inbox/inbox.component';
